import { ReactNode } from 'react';

type TagProps = { children: ReactNode };

export const Tag = ({ children }: TagProps) => {
  return (
    <span
      className={
        'border text-center rounded text-color-dark bg-lightest padding-left-10 padding-right-10'
      }
    >
      {children}
    </span>
  );
};
